import React from "react";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";

import Paper from "@mui/material/Paper";
import { makeStyles } from "tss-react/mui";

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()(() => ({
  paper: {
    margin: 20,
    padding: 20,
  },
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function privacyPolicy() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Privacy Policy | Content Generator - Content Marketing Automation`}
        description={`Content Generator's comprehensive privacy policy. Learn how we protect your data, handle user information, and maintain security standards for our content marketing automation platform and services.`}
        url={`https://contentgenerator.io/privacy-policy`}
      />
      <Paper className={classes.paper}>
        <div>
          <h1>PRIVACY POLICY</h1>
          <p>
            <br />
          </p>
          <p>
            This privacy policy applies between you, the User of this Website
            and Content Generator, the owner and provider of this Website.
            Content Generator takes the privacy of your information very
            seriously. This privacy policy applies to our use of any and all
            Data collected by us or provided by you in relation to your use of
            the Website.
          </p>
          <p>
            This privacy policy should be read alongside, and in addition to,
            our Terms and Conditions, which can be found at:
            https://contentgenerator.io/terms-and-conditions.
          </p>
          <h3>
            Please read this privacy policy carefully<span class="p">.</span>
          </h3>
          <p>
            <br />
          </p>
          <h2>Definitions and interpretation</h2>
          <ol id="l1">
            <li data-list-text="1.">
              <p>In this privacy policy, the following definitions are used:</p>
              <p>
                <br />
              </p>
              <table cellspacing="0">
                <tr>
                  <td bgcolor="#EDEDED">
                    <p class="s1">Data</p>
                  </td>
                  <td bgcolor="#EDEDED">
                    <p class="s2">
                      collectively all information that you submit to Content
                      Generator via the Website. This definition incorporates,
                      where applicable, the definitions provided in the Data
                      Protection Laws;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="s1">Cookies</p>
                  </td>
                  <td>
                    <p class="s2">
                      a small text file placed on your computer by this Website
                      when you visit certain parts of the Website and
                    </p>
                    <p class="s2">
                      /or when you use certain features of the Website. Details
                      of the cookies used by this Website are set out in the
                      clause below (<b>Cookies</b>);
                    </p>
                  </td>
                </tr>
                <tr>
                  <td bgcolor="#EDEDED">
                    <p class="s1">Data Protection Laws</p>
                  </td>
                  <td bgcolor="#EDEDED">
                    <p class="s2">
                      any applicable law relating to the processing of personal
                      Data, including but not limited to the GDPR, and any
                      national implementing and supplementary laws, regulations
                      and secondary legislation;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="s1">GDPR</p>
                  </td>
                  <td>
                    <p class="s2">the UK General Data Protection Regulation;</p>
                  </td>
                </tr>
                <tr>
                  <td bgcolor="#EDEDED">
                    <p class="s1">Content Generator</p>
                    <p class="s1">,</p>
                    <p class="s1">
                      we <span class="s2">or </span>us
                    </p>
                  </td>
                  <td bgcolor="#EDEDED">
                    <p class="s2">
                      Content Generator of 3rd Floor Cape Town Office, 62
                      Roeland st, Cape Town Office, South Africa, 8001;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="s1">UK and EU</p>
                    <p class="s1">Cookie Law</p>
                  </td>
                  <td>
                    <p class="s2">
                      the Privacy and Electronic Communications (EC Directive)
                      Regulations 2003 as amended by the Privacy and Electronic
                      Communications (EC Directive) (Amendment) Regulations 2011
                      &amp; the Privacy and Electronic Communications (EC
                      Directive) (Amendment) Regulations 2018;
                    </p>
                  </td>
                </tr>
                <tr>
                  <td bgcolor="#EDEDED">
                    <p class="s1">
                      User <span class="s2">or</span>
                    </p>
                    <p class="s1">you</p>
                  </td>
                  <td bgcolor="#EDEDED">
                    <p class="s2">
                      any third party that accesses the Website and is not
                      either (i) employed by Content Generator and acting in the
                      course of their employment or (ii) engaged as a consultant
                      or otherwise providing services to Content Generator and
                      accessing the Website in connection with the provision of
                      such services; and
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="s1">Website</p>
                  </td>
                  <td>
                    <p class="s2">
                      the website that you are currently using,
                      https://contentgenerator.io, and any sub-domains of this
                      site unless expressly excluded by their own terms and
                      conditions.
                    </p>
                  </td>
                </tr>
              </table>
              <p>
                <br />
              </p>
            </li>
            <li data-list-text="2.">
              <p>
                In this privacy policy, unless the context requires a different
                interpretation:
              </p>
              <ol id="l2">
                <li data-list-text="a.">
                  <p>the singular includes the plural and vice versa;</p>
                </li>
                <li data-list-text="b.">
                  <p>
                    references to sub-clauses, clauses, schedules or appendices
                    are to sub-clauses, clauses, schedules or appendices of this
                    privacy policy;
                  </p>
                </li>
                <li data-list-text="c.">
                  <p>
                    a reference to a person includes firms, companies,
                    government entities, trusts and partnerships;
                  </p>
                </li>
                <li data-list-text="d.">
                  <p>
                    &quot;including&quot; is understood to mean &quot;including
                    without limitation&quot;;
                  </p>
                </li>
                <li data-list-text="e.">
                  <p>
                    reference to any statutory provision includes any
                    modification or amendment of it;
                  </p>
                </li>
                <li data-list-text="f.">
                  <p>
                    the headings and sub-headings do not form part of this
                    privacy policy.
                  </p>
                  <p>
                    <br />
                  </p>
                  <h2>Scope of this privacy policy</h2>
                </li>
              </ol>
            </li>
            <li data-list-text="3.">
              <p class="s3">
                <span class="p">
                  This privacy policy applies only to the actions of Content
                  Generator and Users with respect to this Website. It does not
                  extend to any websites that can be accessed from this Website
                  including, but not limited to, any links we may provide to
                  social media websites.
                </span>
              </p>
            </li>
            <li data-list-text="4.">
              <p class="s3">
                <span class="p">
                  For purposes of the applicable Data Protection Laws, Content
                  Generator is the &quot;data controller&quot;. This means that
                  Content Generator determines the purposes for which, and the
                  manner in which, your Data is processed.
                </span>
              </p>
              <p>
                <br />
              </p>
              <h2>Data collected</h2>
            </li>
            <li data-list-text="5.">
              <p>
                We may collect the following Data, which includes personal Data,
                from you:
              </p>
              <ol id="l3">
                <li data-list-text="a.">
                  <p>name;</p>
                </li>
                <li data-list-text="b.">
                  <p>gender;</p>
                </li>
                <li data-list-text="c.">
                  <p>
                    contact Information such as email addresses and telephone
                    numbers;
                  </p>
                </li>
                <li data-list-text="d.">
                  <p>
                    demographic information such as postcode, preferences and
                    interests;
                  </p>
                </li>
                <li data-list-text="e.">
                  <p>
                    financial information such as credit / debit card numbers;
                  </p>
                </li>
                <li data-list-text="f.">
                  <p>web browser type and version (automatically collected);</p>
                </li>
                <li data-list-text="g.">
                  <p>operating system (automatically collected);</p>
                </li>
                <li data-list-text="h.">
                  <p>
                    a list of URLs starting with a referring site, your activity
                    on this Website, and the site you exit to (automatically
                    collected);
                  </p>
                  <p>in each case, in accordance with this privacy policy.</p>
                  <p>
                    <br />
                  </p>
                  <h2>How we collect Data</h2>
                </li>
              </ol>
            </li>
            <li data-list-text="6.">
              <p>We collect Data in the following ways:</p>
              <ol id="l4">
                <li data-list-text="a.">
                  <p>data is given to us by you ;</p>
                </li>
                <li data-list-text="b.">
                  <p>data is received from other sources; and</p>
                </li>
                <li data-list-text="c.">
                  <p>data is collected automatically.</p>
                  <p>
                    <br />
                  </p>
                  <h2>Data that is given to us by you</h2>
                </li>
              </ol>
            </li>
            <li data-list-text="7.">
              <p>
                Content Generator will collect your Data in a number of ways,
                for example:
              </p>
              <ol id="l5">
                <li data-list-text="a.">
                  <p>
                    when you contact us through the Website, by telephone, post,
                    e-mail or through any other means;
                  </p>
                </li>
                <li data-list-text="b.">
                  <p>
                    when you register with us and set up an account to receive
                    our products/services;
                  </p>
                </li>
                <li data-list-text="c.">
                  <p>
                    when you make payments to us, through this Website or
                    otherwise;
                  </p>
                </li>
                <li data-list-text="d.">
                  <p>
                    when you elect to receive marketing communications from us;
                  </p>
                  <p>in each case, in accordance with this privacy policy.</p>
                  <p>
                    <br />
                  </p>
                  <h2>
                    Data that is received from publicly available third parties
                    sources
                  </h2>
                </li>
              </ol>
            </li>
            <li data-list-text="8.">
              <p>
                We will receive Data about you from the following publicly
                available third party sources:
              </p>
              <ol id="l6">
                <li data-list-text="a.">
                  <p>Google Analytics.</p>
                  <p>
                    <br />
                  </p>
                  <h2>Data that is collected automatically</h2>
                </li>
              </ol>
            </li>
            <li data-list-text="9.">
              <p>
                To the extent that you access the Website, we will collect your
                Data automatically, for example:
              </p>
              <ol id="l7">
                <li data-list-text="a.">
                  <p>
                    we automatically collect some information about your visit
                    to the Website. This information helps us to make
                    improvements to Website content and navigation, and includes
                    your IP address, the date, times and frequency with which
                    you access the Website and the way you use and interact with
                    its content.
                  </p>
                </li>
                <li data-list-text="b.">
                  <p>
                    we will collect your Data automatically via cookies, in line
                    with the cookie settings on your browser. For more
                    information about cookies, and how we use them on the
                    Website, see the section below, headed &quot;Cookies&quot;.
                  </p>
                  <p>
                    <br />
                  </p>
                  <h2>Our use of Data</h2>
                </li>
              </ol>
            </li>
            <li data-list-text="10.">
              <p class="s3">
                <span class="p">
                  Any or all of the above Data may be required by us from time
                  to time in order to provide you with the best possible service
                  and experience when using our Website. Specifically, Data may
                  be used by us for the following reasons:
                </span>
              </p>
              <ol id="l8">
                <li data-list-text="a.">
                  <p>internal record keeping;</p>
                </li>
                <li data-list-text="b.">
                  <p>improvement of our products / services;</p>
                </li>
                <li data-list-text="c.">
                  <p>
                    transmission by email of marketing materials that may be of
                    interest to you;
                  </p>
                </li>
                <li data-list-text="d.">
                  <p>
                    contact for market research purposes which may be done using
                    email, telephone, fax or mail. Such information may be used
                    to customise or update the Website;
                  </p>
                  <p>in each case, in accordance with this privacy policy.</p>
                </li>
              </ol>
            </li>
            <li data-list-text="11.">
              <p class="s3">
                <span class="p">
                  We may use your Data for the above purposes if we deem it
                  necessary to do so for our legitimate interests. If you are
                  not satisfied with this, you have the right to object in
                  certain circumstances (see the section headed &quot;Your
                  rights&quot; below).
                </span>
              </p>
            </li>
            <li data-list-text="12.">
              <p>
                For the delivery of direct marketing to you via e-mail,
                we&#39;ll need your consent, whether via an opt-in or
                soft-opt-in:
              </p>
              <ol id="l9">
                <li data-list-text="a.">
                  <p>
                    soft opt-in consent is a specific type of consent which
                    applies when you have previously engaged with us (for
                    example, you contact us to ask us for more details about a
                    particular product/service, and we are marketing similar
                    products/services). Under &quot;soft opt-in&quot; consent,
                    we will take your consent as given unless you opt-out.
                  </p>
                </li>
                <li data-list-text="b.">
                  <p>
                    for other types of e-marketing, we are required to obtain
                    your explicit consent; that is, you need to take positive
                    and affirmative action when consenting by, for example,
                    checking a tick box that we&#39;ll provide.
                  </p>
                </li>
                <li data-list-text="c.">
                  <p>
                    if you are not satisfied about our approach to marketing,
                    you have the right to withdraw consent at any time. To find
                    out how to withdraw your consent, see the section headed
                    &quot;Your rights&quot; below.
                  </p>
                </li>
              </ol>
            </li>
            <li data-list-text="13.">
              <p class="s3">
                <span class="p">
                  When you register with us and set up an account to receive our
                  services, the legal basis for this processing is the
                  performance of a contract between you and us and/or taking
                  steps, at your request, to enter into such a contract.
                </span>
              </p>
              <p>
                <br />
              </p>
              <h2>Who we share Data with</h2>
            </li>
            <li data-list-text="14.">
              <p>
                We may share your Data with the following groups of people for
                the following reasons:
              </p>
              <ol id="l10">
                <li data-list-text="a.">
                  <p>
                    our employees, agents and/or professional advisors - to fix
                    software bugs and make marketing decisions;
                  </p>
                  <p>in each case, in accordance with this privacy policy.</p>
                  <p>
                    <br />
                  </p>
                  <h2>Keeping Data secure</h2>
                </li>
              </ol>
            </li>
            <li data-list-text="15.">
              <p>
                We will use technical and organisational measures to safeguard
                your Data, for example:
              </p>
              <ol id="l11">
                <li data-list-text="a.">
                  <p>
                    access to your account is controlled by a password and a
                    user name that is unique to you.
                  </p>
                </li>
                <li data-list-text="b.">
                  <p>we store your Data on secure servers.</p>
                </li>
                <li data-list-text="c.">
                  <p>
                    payment details are encrypted using SSL technology
                    (typically you will see a lock icon or green address bar (or
                    both) in your browser when we use this technology.
                  </p>
                </li>
              </ol>
            </li>
            <li data-list-text="16.">
              <p>
                We are certified to ISO 27001. This family of standards helps us
                manage your Data and keep it secure.
              </p>
            </li>
            <li data-list-text="17.">
              <p class="s3">
                <a
                  href="mailto:info@contentgenerator.io"
                  class="a"
                  target="_blank"
                >
                  Technical and organisational measures include measures to deal
                  with any suspected data breach. If you suspect any misuse or
                  loss or unauthorised access to your Data, please let us know
                  immediately by contacting us via this e-mail address:{" "}
                </a>
                <a href="mailto:info@contentgenerator.io" target="_blank">
                  info@contentgenerator.io.
                </a>
              </p>
            </li>
            <li data-list-text="19.">
              <p class="s3">
                <span class="p">
                  Unless a longer retention period is required or permitted by
                  law, we will only hold your Data on our systems for the period
                  necessary to fulfil the purposes outlined in this privacy
                  policy or until you request that the Data be deleted.
                </span>
              </p>
            </li>
            <li data-list-text="20.">
              <p>
                Even if we delete your Data, it may persist on backup or
                archival media for legal, tax or regulatory purposes.
              </p>
              <p>
                <br />
              </p>
              <h2>Your rights</h2>
            </li>
            <li data-list-text="21.">
              <p>You have the following rights in relation to your Data:</p>
              <ol id="l12">
                <li data-list-text="a.">
                  <h3>
                    Right to access
                    <span class="p">
                      - the right to request (i) copies of the information we
                      hold about you at any time, or (ii) that we modify, update
                      or delete such information. If we provide you with access
                      to the information we hold about you, we will not charge
                      you for this, unless your request is &quot;manifestly
                      unfounded or excessive.&quot; Where we are legally
                      permitted to do so, we may refuse your request. If we
                      refuse your request, we will tell you the reasons why.
                    </span>
                  </h3>
                </li>
                <li data-list-text="b.">
                  <h3>
                    Right to correct
                    <span class="p">
                      - the right to have your Data rectified if it is
                      inaccurate or incomplete.
                    </span>
                  </h3>
                </li>
                <li data-list-text="c.">
                  <h3>
                    Right to erase
                    <span class="p">
                      - the right to request that we delete or remove your Data
                      from our systems.
                    </span>
                  </h3>
                </li>
                <li data-list-text="d.">
                  <h3>
                    Right to restrict our use of your Data
                    <span class="p">
                      - the right to &quot;block&quot; us from using your Data
                      or limit the way in which we can use it.
                    </span>
                  </h3>
                </li>
                <li data-list-text="e.">
                  <h3>
                    Right to data portability
                    <span class="p">
                      - the right to request that we move, copy or transfer your
                      Data.
                    </span>
                  </h3>
                </li>
                <li data-list-text="f.">
                  <h3>
                    Right to object
                    <span class="p">
                      - the right to object to our use of your Data including
                      where we use it for our legitimate interests.
                    </span>
                  </h3>
                </li>
              </ol>
            </li>
            <li data-list-text="22.">
              <p class="s3">
                <a
                  href="mailto:info@contentgenerator.io"
                  class="a"
                  target="_blank"
                >
                  To make enquiries, exercise any of your rights set out above,
                  or withdraw your consent to the processing of your Data (where
                  consent is our legal basis for processing your Data), please
                  contact us via this e-mail address:{" "}
                </a>
                <a href="mailto:info@contentgenerator.io" target="_blank">
                  info@contentgenerator.io.
                </a>
              </p>
            </li>
            <li data-list-text="23.">
              <p class="s3">
                <span class="p">
                  If you are not satisfied with the way a complaint you make in
                  relation to your Data is handled by us, you may be able to
                  refer your complaint to the relevant data protection
                  authority. For the UK, this is the Information
                  Commissioner&#39;s Office (ICO). The ICO&#39;s contact details
                  can be found on their website at https://ico.org.uk/.
                </span>
              </p>
            </li>
            <li data-list-text="24.">
              <p class="s3">
                <span class="p">
                  It is important that the Data we hold about you is accurate
                  and current. Please keep us informed if your Data changes
                  during the period for which we hold it.
                </span>
              </p>
              <p>
                <br />
              </p>
              <h2>Requests from Public Authorities</h2>
            </li>
            <li data-list-text="25.">
              <p class="s3">
                <span class="p">
                  We take the privacy of our users seriously. In the event we
                  receive a request from a government, regulator, or other
                  public authority for access to user data, we handle such
                  requests in accordance with the following principles:
                </span>
              </p>
              <ol id="l13">
                <li data-list-text="a.">
                  <h3>
                    Legal Review
                    <span class="p">
                      - All requests are subject to review to confirm they are
                      valid, lawful, and binding under applicable law.
                    </span>
                  </h3>
                </li>
                <li data-list-text="b.">
                  <h3>
                    Challenging Unlawful Requests
                    <span class="p">
                      - If a request appears unlawful, overly broad, or
                      inconsistent with applicable legal standards, we reserve
                      the right to challenge or refuse the request.
                    </span>
                  </h3>
                </li>
                <li data-list-text="c.">
                  <h3>
                    Data Minimization
                    <span class="p">
                      - We apply the principle of data minimization and will
                      only disclose the minimum amount of information necessary
                      to comply with a valid legal request.
                    </span>
                  </h3>
                </li>
                <li data-list-text="d.">
                  <h3>
                    Documentation and Transparency
                    <span class="p">
                      - We maintain internal documentation of all requests,
                      including the legal basis, our response, and the actors
                      involved in the decision-making process.
                    </span>
                  </h3>
                </li>
              </ol>
              <p class="s3">
                <span class="p">
                  These safeguards ensure that user data is disclosed only when
                  strictly required by law and with respect for the privacy
                  rights of our users.
                </span>
              </p>
              <p>
                <br />
              </p>
              <h2>Links to other websites</h2>
            </li>
            <li data-list-text="26.">
              <p class="s3">
                <span class="p">
                  This Website may, from time to time, provide links to other
                  websites. We have no control over such websites and are not
                  responsible for the content of these websites. This privacy
                  policy does not extend to your use of such websites. You are
                  advised to read the privacy policy or statement of other
                  websites prior to using them.
                </span>
              </p>
              <p>
                <br />
              </p>
              <h2>Changes of business ownership and control</h2>
            </li>
            <li data-list-text="27.">
              <p class="s3">
                <span class="p">
                  Content Generator may, from time to time, expand or reduce our
                  business and this may involve the sale and/or the transfer of
                  control of all or part of Content Generator. Data provided by
                  Users will, where it is relevant to any part of our business
                  so transferred, be transferred along with that part and the
                  new owner or newly controlling party will, under the terms of
                  this privacy policy, be permitted to use the Data for the
                  purposes for which it was originally supplied to us.
                </span>
              </p>
            </li>
            <li data-list-text="28.">
              <p>
                We may also disclose Data to a prospective purchaser of our
                business or any part of it.
              </p>
            </li>
            <li data-list-text="29.">
              <p>
                In the above instances, we will take steps with the aim of
                ensuring your privacy is protected.
              </p>
              <h2>Cookies</h2>
            </li>
            <li data-list-text="30.">
              <p>
                This Website may place and access certain Cookies on your
                computer.
              </p>
              <p>
                <br />
              </p>
              <p>Content Generator uses Cookies to improve your</p>
              <p>
                experience of using the Website and to improve our range of
                services. Content Generator has carefully chosen these Cookies
                and has taken steps to ensure that your privacy is protected and
                respected at all times.
              </p>
            </li>
            <li data-list-text="31.">
              <p>
                All Cookies used by this Website are used in accordance with
                current UK and EU Cookie Law.
              </p>
            </li>
            <li data-list-text="32.">
              <p class="s3">
                <span class="p">
                  Before the Website places Cookies on your computer, you will
                  be presented with a message bar requesting your consent to set
                  those Cookies. By giving your consent to the placing of
                  Cookies, you are enabling Content Generator to provide a
                  better experience and service to you. You may, if you wish,
                  deny consent to the placing of Cookies; however certain
                  features of the Website may not function fully or as intended.
                </span>
              </p>
            </li>
            <li data-list-text="33.">
              <p>This Website may place the following Cookies:</p>
              <p>
                <br />
              </p>
              <table cellspacing="0">
                <tr>
                  <td>
                    <p class="s1">Type of Cookie</p>
                  </td>
                  <td>
                    <p class="s1">Purpose</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="s2">Strictly necessary cookies</p>
                  </td>
                  <td>
                    <p class="s2">
                      These are cookies that are required for the operation of
                      our website. They include, for example, cookies that
                      enable you to log into secure areas of our website, use a
                      shopping cart or make use of e-billing services.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="s2">Analytical/performance cookies</p>
                  </td>
                  <td>
                    <p class="s2">
                      They allow us to recognise and count the number of
                      visitors and to see how visitors move around our website
                      when they are using it. This helps us to improve the way
                      our website works, for example, by ensuring that users are
                      finding what they are looking for easily.
                    </p>
                  </td>
                </tr>
              </table>
              <p>
                <br />
              </p>
            </li>
            <li data-list-text="34.">
              <p>
                You can find a list of Cookies that we use in the Cookies
                Schedule.
              </p>
            </li>
            <li data-list-text="35.">
              <p class="s3">
                <span class="p">
                  You can choose to enable or disable Cookies in your internet
                  browser. By default, most internet browsers accept Cookies but
                  this can be changed. For further details, please consult the
                  help menu in your internet browser.
                </span>
              </p>
            </li>
            <li data-list-text="36.">
              <p class="s3">
                <span class="p">
                  You can choose to delete Cookies at any time; however you may
                  lose any information that enables you to access the Website
                  more quickly and efficiently including, but not limited to,
                  personalisation settings.
                </span>
              </p>
            </li>
            <li data-list-text="37.">
              <p class="s3">
                <span class="p">
                  It is recommended that you ensure that your internet browser
                  is up-to-date and that you consult the help and guidance
                  provided by the developer of your internet browser if you are
                  unsure about adjusting your privacy settings.
                </span>
              </p>
            </li>
            <li data-list-text="38.">
              <p class="s3">
                <span class="p">
                  For more information generally on cookies, including how to
                  disable them, please refer to aboutcookies.org. You will also
                  find details on how to delete cookies from your computer.
                </span>
              </p>
              <p>
                <br />
              </p>
              <h2>General</h2>
            </li>
            <li data-list-text="39.">
              <p class="s3">
                <span class="p">
                  You may not transfer any of your rights under this privacy
                  policy to any other person. We may transfer our rights under
                  this privacy policy where we reasonably believe your rights
                  will not be affected.
                </span>
              </p>
            </li>
            <li data-list-text="40.">
              <p class="s3">
                <span class="p">
                  If any court or competent authority finds that any provision
                  of this privacy policy (or part of any provision) is invalid,
                  illegal or unenforceable, that provision or part-provision
                  will, to the extent required, be deemed to be deleted, and the
                  validity and enforceability of the other provisions of this
                  privacy policy will not be affected.
                </span>
              </p>
            </li>
            <li data-list-text="41.">
              <p class="s3">
                <span class="p">
                  Unless otherwise agreed, no delay, act or omission by a party
                  in exercising any right or remedy will be deemed a waiver of
                  that, or any other, right or remedy.
                </span>
              </p>
            </li>
            <li data-list-text="42.">
              <p class="s3">
                <span class="p">
                  This Agreement will be governed by and interpreted according
                  to the law of Indonesia. All disputes arising under the
                  Agreement will be subject to the exclusive jurisdiction of the
                  Indonesian courts.
                </span>
              </p>
              <p>
                <br />
              </p>
              <h2>Changes to this privacy policy</h2>
            </li>
            <li data-list-text="43.">
              <p class="s3">
                <span class="p">
                  Content Generator reserves the right to change this privacy
                  policy as we may deem necessary from time to time or as may be
                  required by law. Any changes will be immediately posted on the
                  Website and you are deemed to have accepted the terms of the
                  privacy policy on your first use of the Website following the
                  alterations.
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>
                <a
                  href="mailto:info@contentgenerator.io"
                  class="a"
                  target="_blank"
                >
                  You may contact Content Generator by email at{" "}
                </a>
                <a href="mailto:info@contentgenerator.io" target="_blank">
                  info@contentgenerator.io.
                </a>
              </p>
            </li>
          </ol>
          <h3>06 April 2021</h3>
          <h2>Cookies</h2>
          <p>
            Below is a list of the cookies that we use. We have tried to ensure
            this is complete and up to date, but if you think that we have
            missed a cookie or there is any discrepancy, please let us know.
          </p>
          <p>Authentication</p>
          <p>
            We use a cookie to keep track of your authentication so that we can
            sign you in automatically.
          </p>
          <br />
          <p>Analytics</p>
          <p>
            We use a cookie to keep track of our analytics so that we can see
            how many people are using our website and how they are using it. We
            use Google analytics.
          </p>
          <br />
          <p>Conversion tracking</p>
          <p>
            We use a cookie to keep track of our any conversions that happen on
            our website. We use Google adwords, Facebook pixel and Pinterest
            ads.
          </p>
          <br />
        </div>
      </Paper>
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps)(privacyPolicy);
